import { render, staticRenderFns } from "./UndefinedMessageBox.vue?vue&type=template&id=45ac0020&scoped=true&"
import script from "./UndefinedMessageBox.vue?vue&type=script&lang=js&"
export * from "./UndefinedMessageBox.vue?vue&type=script&lang=js&"
import style0 from "./UndefinedMessageBox.vue?vue&type=style&index=0&id=45ac0020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ac0020",
  null
  
)

export default component.exports